import { LabelingWorkflow } from '../service/labeling-workflow.js'
import { WorkflowExecution } from '../service/workflow-execution.js'
import { WorkflowExecutionStep } from '../service/workflow-execution-step.js'

export const entities = [LabelingWorkflow, WorkflowExecution, WorkflowExecutionStep]

export { LabelingWorkflow, WorkflowExecution, WorkflowExecutionStep }
